module.exports = __webpack_public_path__ + "static/media/icon-lock-unlocked.61f5b440.svg";